import MilestonesSerializer from './base';

export default class Level extends MilestonesSerializer {
  normalize(modelClass, payload) {
    payload.goal_subject_id = payload.goalSubjectId;
    return super.normalize(...arguments);
  }
}
